import { Component, OnInit, Input } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'lib-client-sub-nav',
  templateUrl: './client-sub-nav.component.html',
  styleUrls: ['./client-sub-nav.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(50, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        // :leave is alias to '* => void'
        animate(50, style({ opacity: 0 }))
      ])
    ])
  ],
  standalone: false
})
export class ClientSubNavComponent implements OnInit {
  @Input() activeTab = 'Home';

  render: boolean = true;
  constructor() {}

  ngOnInit() {
    this.render = true;
  }
}
